import axios from 'axios';
import cookie from '../cookieHelper/cookie';

export default function deleteStory(companyId) {
    const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/story/' + companyId + '/delete';
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME); // Fetch the token from cookies

    return (
        axios.post(
            API_URL,
            {}, 
            {
                headers: {
                    Authorization: `Bearer ${authToken}`, // Add the Bearer token in the header
                },
            }
        )
        .then(res => {
            // console.log('res delete: ', res);
            return res;
        })
        .catch(err => {
            // console.log('err delete: ', err);
            return err;
        })
    );
}
